import { render, staticRenderFns } from "./DestroyInsertionOrderModal.vue?vue&type=template&id=33a1d370&"
import script from "./DestroyInsertionOrderModal.vue?vue&type=script&lang=js&"
export * from "./DestroyInsertionOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports